import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FieldLabel from "../../../components/label";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { isCustomerDetailsProceedButtonDisabled } from "../../../helpers/validation";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function CustomerDetailsUnfilledForm({
  classes: { accordianSection, contentScroller, formGroup },
  accordian,
  capturePan,
  form,
  errorMessage,
  isFormSubmitted,
  handleAccordianClick,
  handleChange,
  handleCheckboxChange,
  cities,
  panErrorMessage = "",
  isPanVerifiedError = "",
  states,
  selectedCityOption,
  setSelectedCityOption,
  selectedStateOption,
  setSelectedStateOption,
  validateInputLength,
  verifyPancardDetails,
  orderDetails,
}) {
  return (
    <>
      <Box
        className={accordianSection}
        onClick={() => handleAccordianClick("unfilled", accordian.unfilled)}
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {isCustomerDetailsProceedButtonDisabled(
            isFormSubmitted,
            form,
            errorMessage,
            selectedCityOption,
            selectedStateOption
          ) && <NewReleasesOutlinedIcon />}
          {!isCustomerDetailsProceedButtonDisabled(
            isFormSubmitted,
            form,
            errorMessage,
            selectedCityOption,
            selectedStateOption
          ) && <CheckCircleOutlineIcon sx={{ color: "green" }} />}
          <Typography variant="subtitle2">Required Details</Typography>
        </Stack>
        <Box>
          {!accordian.unfilled && <ExpandMoreIcon fontSize="medium" />}
          {accordian.unfilled && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {accordian.unfilled && (
        <Box
          p={1}
          mt={0}
          pt={0}
          sx={{ height: window.screen.height < 740 ? "356px" : "406px" }}
          className={contentScroller}
        >
          <Box className={formGroup}>
            <FieldLabel label={"Mobile*"} pt={0} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.mobile}
              name="mobile"
              onInput={validateInputLength}
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.mobile}
              inputMode="numeric"
              fullWidth
              disabled={true}
            />
          </Box>

          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Email"} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.email}
              name="email"
              onInput={validateInputLength}
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.email}
              fullWidth
            />
          </Box>

          {form.captureFatherName && (
            <Box className={formGroup} pt={0}>
              <FieldLabel label={"Father Name*"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.father_name}
                name="father_name"
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.father_name}
                fullWidth
              />
            </Box>
          )}

          {(capturePan ||
            form.dedupePan ||
            form.panRequired ||
            orderDetails?.panNumber) && (
            <>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Box className={formGroup} pb={0}>
                    <FieldLabel
                      label={capturePan ? "PAN Number*" : "PAN Number"}
                    />
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={7}>
                  <Box className={formGroup} pt={0}>
                    <TextField
                      id="standard-basic"
                      variant="outlined"
                      value={form.pan_number}
                      name="pan_number"
                      onChange={handleChange}
                      onInput={validateInputLength}
                      autoComplete="off"
                      helperText={errorMessage.pan_number}
                      disabled={form.verify_pan_number}
                      fullWidth
                      inputProps={{ style: { textTransform: "uppercase" } }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={4}>
                  <Box
                    className={formGroup}
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"end"}
                    fullWidth
                  >
                    {form.verify_pan_number ? (
                      <Button
                        type="button"
                        variant="contained"
                        size="small"
                        color="success"
                        startIcon={<CheckCircleIcon />}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Verified
                      </Button>
                    ) : (
                      <Button
                        type="button"
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={verifyPancardDetails}
                        {...((!form.pan_number ||
                          errorMessage.pan_number ||
                          isFormSubmitted ||
                          !form.declaration) && {
                          disabled: true,
                        })}
                      >
                        Verify
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>

              {isPanVerifiedError && (
                <Box mb={1} sx={{ color: "red", textAlign: "left" }}>
                  <Typography variant="caption" className="error-message">
                    {panErrorMessage}
                  </Typography>
                </Box>
              )}

              <Box mb={1} sx={{ textAlign: "left" }}>
                <FormControlLabel
                  control={
                    <Box style={{ alignSelf: "start" }}>
                      <Checkbox
                        checked={form.declaration}
                        onChange={handleCheckboxChange}
                        name={"declaration"}
                        color="primary"
                        disabled={form.verify_pan_number}
                      />
                    </Box>
                  }
                  label={
                    <Box mt={1}>
                      <Typography variant="caption">
                        <small>
                          I hereby confirm that the name fetched from PAN card
                          and from Aadhaar card are of the same person.
                        </small>
                      </Typography>
                    </Box>
                  }
                />
              </Box>
            </>
          )}

          <Box className={formGroup} pt={0}>
            <FieldLabel label={"State*"} />
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={states}
              value={selectedStateOption}
              onChange={(event, newValue) => {
                setSelectedStateOption(newValue);
              }}
              fullWidth
              renderInput={(params) => <TextField {...params} label="" />}
              sx={{
                "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                  backgroundColor: "#F6F6F6",
                  fontWeight: "400 !important",
                  display: "flex",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  margin: "2px 0px",
                },
              }}
            />
          </Box>

          <Box className={formGroup} pt={0}>
            <FieldLabel label={"City*"} />
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={cities}
              filterOptions={(options, { inputValue }) =>
                options.filter((option) =>
                  option.label
                    .toLowerCase()
                    .startsWith(inputValue.toLowerCase())
                )
              }
              value={selectedCityOption}
              onChange={(event, newValue) => {
                setSelectedCityOption(newValue);
              }}
              fullWidth
              renderInput={(params) => <TextField {...params} label="" />}
              sx={{
                "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                  backgroundColor: "#F6F6F6",
                  fontWeight: "400 !important",
                  display: "flex",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  margin: "2px 0px",
                },
              }}
            />
          </Box>
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  CustomerDetailsUnfilledForm
);
